import React from 'react';
import {withRouter} from "react-router";
import {withTranslation} from "react-i18next";
import {Link} from "react-router-dom";

let BackComponent = ({t}) => {
    return <div className="back-link">
            <Link to="/">
                <span className="arrow-left"/> {t('navigation.backToOverview')}
            </Link>
    </div>
};

export default withTranslation() (withRouter(BackComponent))